import { useQueryClient } from 'react-query';

// hook to get react-query cache data
export const useGetFetchQuery = (queryKey: string) => {
   const queryClient = useQueryClient();
   return queryClient.getQueryData(queryKey);
};
